import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom"; // Import useParams
import "../css/taxWise.css";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FileOpenTwoToneIcon from "@mui/icons-material/FileOpenTwoTone";
import Cookies from "js-cookie"; // If you use the js-cookie library to manage cookies
import { Snackbar, Alert } from "@mui/material";
import { AccountTree, SignLanguage } from "@mui/icons-material";

const App = () => {
  const {
    login,
    phoneNumber: paramPhoneNumber,
    officeName,
    serviceId: serviceID,
    contactId: contactID,
    UCID: ucid,
  } = useParams(); // Get URL params

  // For local env, prefill the cookie if not already set
  if (process.env.REACT_APP_ENV === "local" && !Cookies.get("AgentID")) {
    Cookies.set("AgentID", "1147801");
  }

  // Resolve agent login: from param → cookie → fallback (optional)
  let agentLogin =
    login && login !== "0" ? login : Cookies.get("AgentID") || null;

  console.log("Agent login:", agentLogin);

  // Set phone in cookie if available
  if (paramPhoneNumber) {
    Cookies.set("phone", paramPhoneNumber);
  }
  const [activeTab, setActiveTab] = useState("tab1");
  const [phoneNumber, setPhoneNumber] = useState(paramPhoneNumber || ""); // Initialize with param value
  const [messageContent, setMessageContent] = useState(""); // State for message content
  const [agentName, setAgentName] = useState("{Your Name}"); // State for agent name
  const [templates, setTemplates] = useState([]);
  const [language, setLanguage] = useState("English"); // 'en' for English, 'es' for Spanish
  const [templateData, setTemplateData] = useState([]);
  const [loading, setLoading] = useState(false); // Loader state
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [options, setOptions] = useState([]);
  const [officeDid, setOfficeDid] = useState(""); // State to store the response
  const [selectedOption, setSelectedOption] = useState(""); // to track selected option
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [tabsDisabled, setTabsDisabled] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [showButtons, setShowButtons] = useState(true);
  const [showCloseButtons, setShowCloseButtons] = useState(false);
  const [smsTabHidden, setSmsTabHidden] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [summaryData, setSummaryData] = useState("");
  const [showBotSummaryButtons, setShowBotSummaryButtons] = useState(false);
  const [eSignSelectedOption, setESignSelectedOption] = useState("");
  const [isChecked, setIsChecked] = useState(false); // Define state

  const medicalExpenses = [
    "Medical insurance premiums: $",
    "Doctor, dentist, and hospital bills: $",
    "Prescription medications: $",
    "Medical travel (mileage, tolls, parking): $",
    "Long-term care expenses: $",
    "Other qualified medical expenses: $",
  ];

  const paidExpenses = [
    "State and local income taxes paid: $",
    "State and local general sales tax (if applicable): $",
    "Real estate taxes: $",
    "Personal property taxes (e.g., vehicle registration fees): $",
  ];

  const paidInterestExpenses = [
    "Home mortgage interest (Form 1098): $",
    "Points paid on mortgage loan: $",
    "Investment interest: $",
  ];

  const giftToCharityExpenses = [
    "Cash contributions: $",
    "Non-cash contributions (fair market value): $",
    "Out-of-pocket expenses for volunteer work: $",
  ];

  const casualtyTeftExpenses = [
    "Loss amount: $",
    "Insurance reimbursement: $",
    "Net loss amount: $",
  ];

  const miscellaneousExpenses = [
    "Gambling losses (limited to winnings reported): $",
    "Unreimbursed impairment-related work expenses: $",
    "Other qualifying deductions: $",
  ];

  const scheduleCExpense = [
    "Advertising & Marketing",
    "Business Insurance (e.g., liability, workers' compensation)",
    "Commissions & Fees",
    "Contract Labor (Form 1099-NEC required if applicable)",
    "Depreciation & Amortization (attach Form 4562 if required)",
    "Employee Benefits (excluding owner benefits)",
    "Legal & Professional Services",
    "Office Expenses (supplies, software, small equipment, etc.)",
    "Rent or Lease (business property & equipment)",
    "Repairs & Maintenance",
    "Travel (lodging, airfare, meals at 50%)",
    "Utilities (phone, internet, electricity for business use)",
    "Vehicle Expenses (standard mileage or actual expenses)",
    "Wages (excluding owner compensation)",
    "Other Expenses (must be ordinary & necessary)",
  ];

  // State to store input values
  const [amounts, setAmounts] = useState(Array(medicalExpenses.length).fill(0));

  const [paidAmounts, setPaidAmounts] = useState(
    Array(paidExpenses.length).fill(0)
  );

  const [paidInterestAmounts, setPaidInterestAmounts] = useState(
    Array(paidInterestExpenses.length).fill(0)
  );

  const [giftAmount, setGiftAmounts] = useState(
    Array(giftToCharityExpenses.length).fill(0)
  );

  const [casulatyTeftAmounts, setCasilatyTeftAmounts] = useState(
    Array(casualtyTeftExpenses.length).fill(0)
  );

  const [miscellaneousAmounts, setMiscellaneousExpensesAmounts] = useState(
    Array(miscellaneousExpenses.length).fill(0)
  );

  const [schduleCAmounts, setschduleCAmounts] = useState(
    Array(scheduleCExpense.length).fill(0)
  );

  // Calculate total
  const medicalExpense = amounts.reduce((sum, val) => sum + val, 0);

  const paidExpense = paidAmounts.reduce((sum, val) => sum + val, 0);

  const totalPaidInterestExpense = paidInterestAmounts.reduce(
    (sum, val) => sum + val,
    0
  );

  const totalGiftAmount = giftAmount.reduce((sum, val) => sum + val, 0);

  const totalCasualty = casulatyTeftAmounts.reduce((sum, val) => sum + val, 0);

  const totalMicellaneous = miscellaneousAmounts.reduce(
    (sum, val) => sum + val,
    0
  );

  const totalScheduleC = schduleCAmounts.reduce((sum, val) => sum + val, 0);

  const grandTotal =
    medicalExpense +
    paidExpense +
    totalPaidInterestExpense +
    totalGiftAmount +
    totalCasualty +
    totalMicellaneous;

  const handleScheduleCExpenseChange = (index, value) => {
    const newAmounts = [...schduleCAmounts];
    newAmounts[index] = parseFloat(value) || 0;

    setschduleCAmounts(newAmounts);

    formData.advertiseAndMarketingAmount = newAmounts[0];
    formData.businessInsuranceAmount = newAmounts[1];
    formData.comissionFee = newAmounts[2];
    formData.contractLabor = newAmounts[3];
    formData.amortizationAndDepreciationAmount = newAmounts[4];
    formData.employeeBenifitsAmount = newAmounts[5];
    formData.legalAndProfessionalAmount = newAmounts[6];
    formData.officeExpenses = newAmounts[7];
    formData.rentOrLease = newAmounts[8];
    formData.repairAndMaintenance = newAmounts[9];
    formData.travelExpenses = newAmounts[10];
    formData.utilitiesExpenses = newAmounts[11];
    formData.vehicleExpenses = newAmounts[12];
    formData.wages = newAmounts[13];
    formData.otherExpenses = newAmounts[14];
    formData.totalScheduleCExpenses = totalScheduleC;
  };

  // Handle input change and update total
  const handleMedicalExpenseChange = (index, value) => {
    const newAmounts = [...amounts];
    newAmounts[index] = parseFloat(value) || 0;
    setAmounts(newAmounts);

    formData.medicalInsurancePermiums = newAmounts[0];
    formData.hospitalBills = newAmounts[1];
    formData.prescriptionMedications = newAmounts[2];
    formData.medicalTravel = newAmounts[3];
    formData.longTermCareExpenses = newAmounts[4];
    formData.otherQualifiedMedicalExpenses = newAmounts[5];
  };

  // Handle input change and update total
  const handlePaidExpenseChange = (index, value) => {
    const newAmounts = [...paidAmounts];
    newAmounts[index] = parseFloat(value) || 0;
    setPaidAmounts(newAmounts);

    formData.stateAndLocalTaxes = newAmounts[0];
    formData.stateAndLocalGeneralTaxes = newAmounts[1];
    formData.realEstateTaxes = newAmounts[2];
    formData.personalPropertyTexes = newAmounts[3];
  };

  // Handle input change and update total
  const handlePaidInterestExpenseChange = (index, value) => {
    const newAmounts = [...paidInterestAmounts];
    newAmounts[index] = parseFloat(value) || 0;
    setPaidInterestAmounts(newAmounts);

    formData.homeMortgageInterest = newAmounts[0];
    formData.pointsPlanMortgageLoan = newAmounts[1];
    formData.investmentInterest = newAmounts[2];
  };

  // Handle input change and update total
  const handleGitAmountChange = (index, value) => {
    const newAmounts = [...giftAmount];
    newAmounts[index] = parseFloat(value) || 0;
    setGiftAmounts(newAmounts);

    formData.cashContribution = newAmounts[0];
    formData.nonCashContribution = newAmounts[1];
    formData.volunteerContribution = newAmounts[2];
  };

  // Handle input change and update total
  const handleCasualtyChange = (index, value) => {
    const newAmounts = [...casulatyTeftAmounts];
    newAmounts[index] = parseFloat(value) || 0;
    setCasilatyTeftAmounts(newAmounts);

    formData.lossAmount = newAmounts[0];
    formData.netLossAmoount = newAmounts[1];
    formData.insuranceReimbursement = newAmounts[2];
  };

  // Handle input change and update total
  const handleMiscelaneousChange = (index, value) => {
    const newAmounts = [...miscellaneousAmounts];
    newAmounts[index] = parseFloat(value) || 0;
    setMiscellaneousExpensesAmounts(newAmounts);

    formData.gamblingLoss = newAmounts[0];
    formData.unreimbursedImpairmentWork = newAmounts[1];
    formData.otherQualifyingDeduction = newAmounts[2];
  };

  const eSigOptions = [
    "DIRECT DEPOSIT AUTHORIZATION & DISCLOSURE",
    "SCHEDULE C - BUSINESS EXPENSE DISCLOSURE",
    "TAX RETURN DISCLOSURE",
    "SCHEDULE A - ITEMIZED DEDUCTIONS TEMPLATE",
  ];

  // const eSigOptions = ["TAX RETURN DISCLOSURE"];

  // Fetch agent name from API
  useEffect(() => {
    handleVoiceOnly();
    fetchMediaFiles();
    fetchTemplates();
    fetchCustomerData();
    fetchOfficeDetails();
    populateQcode(serviceID, language);
    fetchLanguages();
    if (ucid != 0) {
      // setShowBotSummaryButtons(true)
      // fetchAiDetails()
    }
    const fetchAgentName = async () => {
      try {
        const response = await fetch(
          `  https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/sms/agentName/${agentLogin}`
        );
        if (response.ok) {
          const name = await response.text(); // Assuming API returns plain text
          setAgentName(name || "{Your Name}"); // Update state with the agent name or default to "____"
        } else {
          console.error("Failed to fetch agent name");
          setAgentName("{Your Name}");
        }
      } catch (error) {
        console.error("Error fetching agent name:", error);
        setAgentName("{Your Name}");
      }
    };

    if (agentLogin && agentLogin != 0) {
      fetchAgentName();
    }
  }, [agentLogin]); // Dependency on login to refetch if it changes

  const translations = {
    English: {
      greeting: "Hello! My name is",
      opportunity:
        "and I'm reaching out because I have an opportunity to put money in your pocket fast.",
      taxAdvance:
        "Our tax office partners with banks that allow you to get an advance on your tax refund. In just 24 hours, you could have up to",
      deposit: "deposited directly into your bank account.",
      nameLabel: "Name:",
      spouseNameLabel: "Spouse Name:",
      spouseEmailLabel: "Spouse Email:",
      phoneLabel: "Phone:",
      emailLabel: "Email:",
      selectQCode: "Select QCode:",
      submit: "Submit",
      docusign: "Docusign",
      template: "Select Template",
      messageLabel: "Message Content",
      sendMessageLabel: "Send Message",
      scriptLabel: "Script",
      sendSmsLabel: "Send SMS",
      mediaFilesLabel: "Media Files",
      sendMessageHeader: "Send a Message",
      mediaFilesHeader: "Media Files",
      titleLabel: "Taxwise Script",
      marchAprilScript:
        "The April 15th tax deadline is coming fast—and waiting could cost you! Even with an extension, unpaid taxes still accrue penalties and interest.",
      avoidPenalties: "Avoid penalties & maximize your refund",
      auditDefense: "Get $1M Audit Defense & Identity Theft Protection",
      businessDeductions: "Claim $10K+ in business deductions",
      cleanEnergyCredits: "Unlock IRS credits for clean energy upgrades",
    },
    Spanish: {
      greeting: "¡Hola! Mi nombre es",
      opportunity:
        "y me comunico porque tengo una oportunidad para poner dinero en su bolsillo rápidamente.",
      taxAdvance:
        "Nuestra oficina de impuestos se asocia con bancos que le permiten obtener un adelanto de su reembolso de impuestos. En tan solo 24 horas, podría tener hasta",
      deposit: "depositados directamente en su cuenta bancaria.",
      nameLabel: "Nombre:",
      spouseNameLabel: "Nombre del cónyuge:",
      spouseEmailLabel: "Correo electrónico del cónyuge:",
      phoneLabel: "Teléfono:",
      emailLabel: "Correo electrónico:",
      selectQCode: "Seleccione QCode:",
      submit: "Entregar",
      docusign: "Docusign",
      template: "Seleccionar plantilla",
      messageLabel: "Contenido del mensaje",
      sendMessageLabel: "Enviar mensaje",
      scriptLabel: "Guion",
      sendSmsLabel: "Enviar SMS",
      mediaFilesLabel: "Archivos multimedia",
      sendMessageHeader: "Enviar un mensaje",
      mediaFilesHeader: "Archivos multimedia",
      titleLabel: "Guión de impuestos",
      marchAprilScript:
        "¡La fecha límite de impuestos del 15 de abril se acerca rápidamente, y esperar podría costarte! Incluso con una extensión, los impuestos no pagados siguen acumulando multas e intereses.",
      avoidPenalties: "Evite multas y maximice su reembolso",
      auditDefense:
        "Obtenga $1M en defensa de auditoría y protección contra robo de identidad",
      businessDeductions: "Reclame más de $10K en deducciones comerciales",
      cleanEnergyCredits:
        "Aproveche créditos fiscales del IRS por mejoras en energía limpia",
    },
  };

  const LanguageChange = (event) => {
    setLanguage(event.target.value);
    populateQcode(serviceID, event.target.value);
  };

  const t = translations[language];

  const disableTabs = () => {
    setTabsDisabled(true);
    setIsReadOnly(true);
    setShowButtons(false);
    setShowCloseButtons(true);
  };

  const fetchAiDetails = () => {
    const apiUrl = `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/voicebot/taxDetails?ucid=${ucid}`;
    // const apiUrl = `http://localhost:8080/api/voicebot/taxDetails?ucid=${ucid}`;

    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.callID != null) {
          handleBotSummary(data.callID);
          localStorage.setItem("botCallId", data.callID);
        } else {
          setShowBotSummaryButtons(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching office details:", error);
      });
  };

  const handleBotSummary = async (callId) => {
    setLoading(true);
    console.log("Bot Call ID Type: " + typeof callId !== "string");
    if (callId == null || callId === "" || typeof callId !== "string") {
      callId = localStorage.getItem("botCallId");
      console.log("Bot Call ID: " + callId);
    }

    const url = `https://talentic.ai/agri/getsummary.php?filename=${callId}.txt`;

    try {
      const response = await fetch(url);
      const data = await response.text();

      // Process the data
      const correctData = data
        .replace(/\\n/g, "\n") // Convert escaped newlines to actual newlines
        .split("\n") // Split the string into an array of lines
        .map((line, index) => `${index + 1}) ${line}`) // Add numbering (1), 2), etc.) to each line
        .join("\n") // Join the lines back into a single string
        .replace(/[*-]/g, ""); // Remove any asterisks (*) or hyphens (-)

      // Set the formatted data to state
      setSummaryData(correctData);

      // Open the dialog to display the data
      setIsDialogOpen(true);
    } catch (error) {
      console.error("Error fetching summary:", error);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const fetchOfficeDetails = () => {
    const apiUrl = `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/v1/officeDetails/${officeName}`;

    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text(); // Parse response as text
      })
      .then((data) => {
        console.log("Office DID:", data);
        setOfficeDid(data); // Save response to state
      })
      .catch((error) => {
        console.error("Error fetching office details:", error);
      });
  };

  const fetchTemplates = async () => {
    try {
      // const response = await fetch(`http://localhost:8080/api/sms-templates/templateName/${officeName}`);
      const response = await fetch(
        `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/sms-templates/templateName/${officeName}`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      if (Array.isArray(data)) {
        setTemplates(data);
      } else {
        console.error("Expected an array but got:", data);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  const handleTemplateChange = (e) => {
    setSelectedTemplate(e.target.value);
    handleTemplateLanguageChange(e.target.value, selectedLanguage);
  };

  const handleVoiceOnly = (e) => {
    if (officeName === "HIALEAH_MULTI_SERVICES") {
      setSmsTabHidden(true);
    } else {
      setSmsTabHidden(false);
    }
  };

  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value);
    handleTemplateLanguageChange(selectedTemplate, e.target.value);
  };

  const handleTemplateLanguageChange = async (templateName, language) => {
    try {
      // Make sure both templateName and language are available before making the request
      // if (!templateName || !language) {
      //   console.error('Template or Language not selected');
      //   return; // Prevent API call if either value is missing
      // }
      // Assuming the API takes the template name in the URL and returns template data
      // const response = await fetch(`http://localhost:8080/api/sms-templates/templates-message?templateName=${(templateName)}&language=${(language)}`);
      const response = await fetch(
        `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/sms-templates/templates-message?templateName=${templateName}&language=${language}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch template data");
      }

      const templateData = await response.json();

      const message = templateData[0]?.message; // Access the message of the first template in the array

      if (message) {
        console.log("Message:", message);
        setMessageContent(message); // You can set it in a state if needed to populate a text area, for example
      } else {
        console.error("Message not found");
      }
    } catch (error) {
      console.error("Error fetching template data:", error);
    }
  };

  const handleSendMessage = async () => {
    if (!phoneNumber.trim() || !messageContent.trim()) {
      alert("Please fill out all fields before sending.");
      return;
    }

    const payload = {
      phoneNumber,
      message: `${messageContent}`,
      // message: `${messageContent}/?name=${formData.name ? formData.name : ''}&phone=${phoneNumber}`,
      login: agentLogin,
    };

    try {
      setLoading(true);
      const response = await fetch(
        `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/sms/send/${officeName}`,
        {
          // const response = await fetch(`http://localhost:8080/api/sms/send/${officeName}`, {

          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      // Check if the response is the success message
      const responseText = await response.text(); // Get the response text

      if (responseText === "Message Send Successfully") {
        setLoading(false);
        setSnackbarMessage("SMS Sent successfully");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        // alert("Message sent successfully");
      } else {
        setLoading(false);
        console.error("Failed to send message:", responseText);
        setSnackbarMessage("Failed to Sent SMS");
        setSnackbarSeverity("error");
        setLoading(false);
        setSnackbarOpen(true);
        alert("Failed to send message. Please try again.");
      }
    } catch (error) {
      setSnackbarMessage("Failed to Sent SMS");
      setSnackbarSeverity("error");
      setLoading(false);
      setSnackbarOpen(true);
      setLoading(false);
      console.error("Error while sending message:", error);
      alert("An error occurred. Please try again.");
    }

    setPhoneNumber(""); // Clear phone number input
    setMessageContent(""); // Clear message content input
    setSelectedTemplate("");
  };

  const [formData, setFormData] = useState({
    phone: paramPhoneNumber || "", // Initialize phone number from URL param
    taxYear: "", // Initially empty
  });

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      taxYear: new Date().getFullYear() - 1, // Set previous year after mount
    }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "email") {
      validateEmail(value); // Validate email whenever it changes
    }
  };

  var firstSaved = true;

  const handleSubmit = (e, isDocusign = false, isButtonClick = false) => {
    if (e != null) {
      e.preventDefault();
    }

    if (!isButtonClick) {
      setLoading(true);
    }

    const apiUrl = `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/inboundchat-data`; // Replace with the actual API URL

    const payload = {
      applicant: {
        name: formData.name,
        email: formData.email,
        phoneNumber: formData.phone || "",
        id: formData.applicantId,
        ...(isChecked && {
          spouse: {
            id: formData.spouseId,
            name: formData.spouseName,
            email: formData.spouseEmail,
          },
        }),
        // qcode: formData.qCode  // Uncomment if needed
      },
      taxInfo: {
        joinedAccount: isChecked,

        // Schedule C Values
        advertiseAndMarketingAmount: formData.advertiseAndMarketingAmount,
        businessInsuranceAmount: formData.businessInsuranceAmount,
        comissionFee: formData.comissionFee,
        contractLabor: formData.contractLabor,
        amortizationAndDepreciationAmount:
          formData.amortizationAndDepreciationAmount,
        employeeBenefitsAmount: formData.employeeBenifitsAmount,
        legalAndProfessionalAmount: formData.legalAndProfessionalAmount,
        officeExpenses: formData.officeExpenses,
        rentOrLease: formData.rentOrLease,
        repairAndMaintenance: formData.repairAndMaintenance,
        travelExpenses: formData.travelExpenses,
        utilitiesExpenses: formData.utilitiesExpenses,
        vehicleExpenses: formData.vehicleExpenses,
        wages: formData.wages,
        otherExpenses: formData.otherExpenses,
        totalScheduleCExpenses: formData.totalScheduleCExpenses,
        ssn: formData.socialSecurityNumber,

        // Authorized Disclosure
        bankName: formData.bankName,
        routingNumber: formData.routingNumber,
        accountNumber: formData.accountNumber,
        AccountType: formData.accountType,

        // Schedule A values
        businessName: formData.businessName,
        taxYear: formData.taxYear,
        ein: formData.ein,

        // Schedule A Medical Expenses
        medicalInsurancePermiums: formData.medicalInsurancePermiums,
        hospitalBills: formData.hospitalBills,
        prescriptionMedications: formData.prescriptionMedications,
        medicalTravel: formData.medicalTravel,
        longTermCareExpenses: formData.longTermCareExpenses,
        otherQualifiedMedicalExpenses: formData.otherQualifiedMedicalExpenses,
        totalMedicalDentalExpenses: medicalExpense,

        // Schedule A Tax Paid Expenses
        stateAndLocalTaxes: formData.stateAndLocalTaxes,
        stateAndLocalGeneralTaxes: formData.stateAndLocalGeneralTaxes,
        realEstateTaxes: formData.realEstateTaxes,
        personalPropertyTexes: formData.personalPropertyTexes,
        totalTaxPaidExpenses: paidExpense,

        // Schedule A Interest Paid Expenses
        homeMortgageInterest: formData.homeMortgageInterest,
        pointsPlanMortgageLoan: formData.pointsPlanMortgageLoan,
        investmentInterest: formData.investmentInterest,
        totalInterestPaidExpenses: totalPaidInterestExpense,

        // Schedule A Gifts to Charity Expenses
        cashContribution: formData.cashContribution,
        nonCashContribution: formData.nonCashContribution,
        volunteerContribution: formData.volunteerContribution,
        totalCharityExpenses: totalGiftAmount,

        // Schedule A Casualty and Theft Expenses
        lossAmount: formData.lossAmount,
        netLossAmoount: formData.netLossAmoount,
        insuranceReimbursement: formData.insuranceReimbursement,
        totalCasualtyAndTheft: totalCasualty,

        // Schedule A Miscellaneous Deductions
        gamblingLoss: formData.gamblingLoss,
        unreimbursedImpairmentWork: formData.unreimbursedImpairmentWork,
        otherQualifyingDeduction: formData.otherQualifyingDeduction,
        totalMiscellaneousDeductions: totalMicellaneous,

        // Schedule A Grand Total
        totalScheduleADetection: grandTotal,
      },
      phoneNumber: formData.phone || "",
      login: agentLogin,
      serviceId: serviceID,
      qcode: formData.qCode || 142, // Default to 142 if formData.qCode is empty
      source: "TAX",
      username: formData.name,
      officeDid: officeDid,
      queue: 10,
      contactId: contactID,
      rdate: new Date().toISOString(),
      id: formData.id, // This id is at the top level, outside applicant
    };

    if (firstSaved) {
      // If firstSaved is true, remove the 'id' field
      delete payload.id;
      delete payload.applicant.id;
    }
    // Send the request
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        // if (!response.ok) {
        //   throw new Error(response.text());
        // }
        return response.text(); // Use text() for plain text responses
      })
      .then((data) => {
        console.log("API Response:", data);

        if (!isButtonClick) {
          setSnackbarMessage("Form Submited Successfully");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          setLoading(false);
          handleSetQcode();
        }

        if (firstSaved) {
          firstSaved = false;
          localStorage.setItem("latestRecordId", data?.scriptData?.id);
          fetchCustomerData();
        }
      })
      .catch((error) => {
        setSnackbarMessage("Error: " + error.message);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setLoading(false);
        console.error("Error:", error);
      });
  };

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return "";
  };

  const handleSetQcode = () => {
    // Get the selected QCode from the formData
    const qCode = formData.qCode;
    setLoading(true);

    console.log("GET Code", qCode);

    // Get the session ID from the cookie
    const sessionId = Cookies.get("SessionId"); // Using js-cookie to get the cookie value
    console.log("GET SESSION ID", sessionId);

    // Ensure qCode and sessionId are available
    if (!qCode || !sessionId) {
      console.error("QCode or Session ID is missing!");
      return;
    }

    fetch(
      `https://rms.healtheesystems.com/webagent/Integration.aspx?Operation=SetQCode&QCode=${qCode}&sessionId=${sessionId}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.text(); // Parse response as text
      })
      .then((data) => {
        console.log("Raw XML Response:", data);

        // Parse the XML response
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, "text/xml");

        // Extract specific elements from the XML
        const result = xmlDoc.querySelector("Result")?.textContent;

        if (result === "$00000000") {
          console.log("SET QCODE operation was successful.");
          // setSnackbarMessage('SET QCODE operation was successful.');
          // setSnackbarSeverity('success');
          // setSnackbarOpen(true);
          handleCloseContact(); // Call the function after successful response
        } else {
          console.error("SET QCODE operation failed with result:", result);
          setSnackbarMessage(
            `SET QCODE operation failed with result: ${result}`
          );
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching XML:", error);
        setSnackbarMessage("Error: " + error.message);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      });
  };

  // Close contact function
  const handleCloseContact = () => {
    const sessionId = Cookies.get("SessionId"); // Get session ID from cookie again if needed

    console.log("GET SESSION ID in Close Contact", sessionId);
    setLoading(true);
    fetch(
      `https://rms.healtheesystems.com/webagent/Integration.aspx?Operation=CloseContact&sessionId=${sessionId}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.text(); // Parse response as text
      })
      .then((data) => {
        console.log("Close Contact IS COMPLETED");
        setLoading(false);
        disableTabs();
        localStorage.clear();
        setShowBotSummaryButtons(false);
        // setSnackbarMessage('Form Submitted Successfully');
        // setSnackbarSeverity('Success');
        // setLoading(false);
        // setSnackbarOpen(true);
        // localStorage.clear(); // Clear localStorage if needed
      })
      .catch((error) => {
        setLoading(false);
        setSnackbarMessage("Error: " + error.message);
        setSnackbarSeverity("error");
        setLoading(false);
        setSnackbarOpen(true);
        console.error("Error:", error);
        console.error("Error fetching XML:", error);
        disableTabs();
      });
  };

  const handleEINChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    if (value.length > 2) {
      value = value.slice(0, 2) + "-" + value.slice(2, 9); // Format as XX-XXXXXXX
    }

    if (value.length > 10) {
      value = value.slice(0, 10); // Ensure max length is 10 (including hyphen)
    }

    setFormData({ ...formData, ein: value });
  };

  const handleRoutingNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    if (value.length > 9) {
      value = value.slice(0, 9); // Ensure max length is 9
    }

    setFormData({ ...formData, routingNumber: value });
  };

  const handleAccountNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    if (value.length > 17) {
      value = value.slice(0, 17); // Ensure max length is 17
    }

    setFormData({ ...formData, accountNumber: value });
  };

  const handleSSNChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    if (value.length > 9) {
      value = value.slice(0, 9); // Restrict to 9 digits
    }

    // Apply SSN format (XXX-XX-XXXX)
    if (value.length > 5) {
      value = `${value.slice(0, 3)}-${value.slice(3, 5)}-${value.slice(5)}`;
    } else if (value.length > 3) {
      value = `${value.slice(0, 3)}-${value.slice(3)}`;
    }

    setFormData({ ...formData, socialSecurityNumber: value });
  };

  const validateEmail = (email) => {
    // Simple regex for email validation
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setIsEmailValid(isValid);
  };

  const handleDocusign = (e, isDocusign = false) => {
    e.preventDefault();
    setLoading(true);
    var disclosureType = null;
    if (eSignSelectedOption === "SCHEDULE A - ITEMIZED DEDUCTIONS TEMPLATE") {
      disclosureType = "schedulea";
    } else if (eSignSelectedOption === "TAX RETURN DISCLOSURE") {
      disclosureType = "disclosure";
    } else if (
      eSignSelectedOption === "SCHEDULE C - BUSINESS EXPENSE DISCLOSURE"
    ) {
      disclosureType = "scheduleb";
    } else if (
      eSignSelectedOption === "DIRECT DEPOSIT AUTHORIZATION & DISCLOSURE"
    ) {
      disclosureType = "directdeposit";
    }
    const apiUrl = `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/v1/taxation/get-sig?documentType=${disclosureType}`; // Replace with the actual API URL
    const payload = {
      applicant: {
        name: formData.name,
        email: formData.email,
        phoneNumber: formData.phone || "",
        id: formData.applicantId,
        ...(isChecked && {
          spouse: {
            id: formData.spouseId,
            name: formData.spouseName,
            email: formData.spouseEmail,
          },
        }),
        // qcode: formData.qCode  // Uncomment if needed
      },
      taxInfo: {
        // Schedule C Values
        advertiseAndMarketingAmount: formData.advertiseAndMarketingAmount,
        businessInsuranceAmount: formData.businessInsuranceAmount,
        comissionFee: formData.comissionFee,
        contractLabor: formData.contractLabor,
        amortizationAndDepreciationAmount:
          formData.amortizationAndDepreciationAmount,
        employeeBenefitsAmount: formData.employeeBenifitsAmount,
        legalAndProfessionalAmount: formData.legalAndProfessionalAmount,
        officeExpenses: formData.officeExpenses,
        rentOrLease: formData.rentOrLease,
        repairAndMaintenance: formData.repairAndMaintenance,
        travelExpenses: formData.travelExpenses,
        utilitiesExpenses: formData.utilitiesExpenses,
        vehicleExpenses: formData.vehicleExpenses,
        wages: formData.wages,
        otherExpenses: formData.otherExpenses,
        totalScheduleCExpenses: formData.totalScheduleCExpenses,
        ssn: formData.socialSecurityNumber,

        // Authorized Disclosure
        bankName: formData.bankName,
        routingNumber: formData.routingNumber,
        accountNumber: formData.accountNumber,
        AccountType: formData.accountType,

        // Schedule A values
        businessName: formData.businessName,
        taxYear: formData.taxYear,
        ein: formData.ein,

        // Schedule A Medical Expenses
        medicalInsurancePermiums: formData.medicalInsurancePermiums,
        hospitalBills: formData.hospitalBills,
        prescriptionMedications: formData.prescriptionMedications,
        medicalTravel: formData.medicalTravel,
        longTermCareExpenses: formData.longTermCareExpenses,
        otherQualifiedMedicalExpenses: formData.otherQualifiedMedicalExpenses,
        totalMedicalDentalExpenses: medicalExpense,

        // Schedule A Tax Paid Expenses
        stateAndLocalTaxes: formData.stateAndLocalTaxes,
        stateAndLocalGeneralTaxes: formData.stateAndLocalGeneralTaxes,
        realEstateTaxes: formData.realEstateTaxes,
        personalPropertyTexes: formData.personalPropertyTexes,
        totalTaxPaidExpenses: paidExpense,

        // Schedule A Interest Paid Expenses
        homeMortgageInterest: formData.homeMortgageInterest,
        pointsPlanMortgageLoan: formData.pointsPlanMortgageLoan,
        investmentInterest: formData.investmentInterest,
        totalInterestPaidExpenses: totalPaidInterestExpense,

        // Schedule A Gifts to Charity Expenses
        cashContribution: formData.cashContribution,
        nonCashContribution: formData.nonCashContribution,
        volunteerContribution: formData.volunteerContribution,
        totalCharityExpenses: totalGiftAmount,

        // Schedule A Casualty and Theft Expenses
        lossAmount: formData.lossAmount,
        netLossAmoount: formData.netLossAmoount,
        insuranceReimbursement: formData.insuranceReimbursement,
        totalCasualtyAndTheft: totalCasualty,

        // Schedule A Miscellaneous Deductions
        gamblingLoss: formData.gamblingLoss,
        unreimbursedImpairmentWork: formData.unreimbursedImpairmentWork,
        otherQualifyingDeduction: formData.otherQualifyingDeduction,
        totalMiscellaneousDeductions: totalMicellaneous,

        // Schedule A Grand Total
        totalScheduleADetection: grandTotal,
      },
      phoneNumber: formData.phone || "",
      login: agentLogin,
      serviceId: serviceID,
      qcode: formData.qCode || 118, // Default to 118 if formData.qCode is empty
      source: "TAX",
      username: formData.name,
      officeDid: officeDid,
      queue: 10,
      contactId: contactID,
      rdate: new Date().toISOString(),
      id: formData.id, // This id is at the top level, outside applicant
    };

    // Send the request
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        // if (!response.ok) {
        //   throw new Error(response.text());
        // }
        return response.text(); // Use text() for plain text responses
      })
      .then((data) => {
        console.log("API Response:", data);

        if (data.includes("Document sent to customer for signature")) {
          // Adjust the condition based on the text response content
          setSnackbarMessage(data);
          setSnackbarSeverity("success");
          setLoading(true);
        } else {
          setSnackbarMessage(data);
          setSnackbarSeverity("error");
          setLoading(true);
        }

        setSnackbarOpen(true); // Open the snackbar to show message
        setLoading(true);
        setLoading(false); // Set loading to false after completion
      })
      .catch((error) => {
        setSnackbarMessage("Error: " + error.message);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setLoading(false);
        console.error("Error:", error);
      });
  };

  const populateQcode = (serviceId, selectedLanguage) => {
    fetch(
      `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/v1/IR-Agent/qCode?serviceId=${serviceId}&language=${selectedLanguage}`
    )
      // fetch(`http://localhost:8080/api/v1/IR-Agent/qCode?serviceId=${serviceId}&language=${selectedLanguage}`)
      .then((response) => response.json())
      .then((data) => {
        const jsonData = data;
        const newOptions = jsonData
          .filter((item) => item.code !== null) // Filter out items where code is null
          .map((item) => ({
            value: item.code,
            label: item.description,
          }));
        setOptions(newOptions); // Update state with the new options
      })
      .catch((error) => {
        console.error("Error fetching JSON:", error);
      });
  };

  const fetchCustomerData = async () => {
    try {
      const callId = localStorage.getItem("botCallId");
      const latestId = localStorage.getItem("latestRecordId");
      var url = "";

      if (callId == null || callId === "") {
        url = `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/inboundchat-data/${phoneNumber}?source=TAX`;
      } else if (latestId != null && latestId != "") {
        url = `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/inboundchat-data/id/${latestId}?source=TAX`;
        localStorage.setItem("latestRecordId", null);
      } else {
        url = `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/inboundchat-data/id/${callId}?source=TAX`;
      }

      const response = await fetch(url);
      const data = await response.json();

      // Check if applicant data is null or not
      let applicantEmail = "";
      let applicantId = "";
      let actualPhone = "";
      let actualSpouseId = "";
      let actualSpouseName = "";
      let actualSppouseEmail = "";
      if (data.customerData.applicant != null) {
        // Only set email and applicantId if applicant is not null
        applicantEmail = data.customerData.applicant.email
          ? data.customerData.applicant.email
          : "";
        applicantId = data.customerData.applicant.id
          ? data.customerData.applicant.id
          : "";

        if (data.customerData.applicant.spouse != null) {
          actualSpouseId = data.customerData.applicant.spouse.id
            ? data.customerData.applicant.spouse.id
            : "";
          actualSpouseName = data.customerData.applicant.spouse.name
            ? data.customerData.applicant.spouse.name
            : "";
          actualSppouseEmail = data.customerData.applicant.spouse.email
            ? data.customerData.applicant.spouse.email
            : "";
        }
      }

      if (data.customerData.phoneNumber != phoneNumber) {
        console.log("Phone Number Not Matched");
        actualPhone = data.customerData.phoneNumber;
      } else {
        console.log("Phone Number Matched");
        actualPhone = phoneNumber;
      }

      console.log("Actual PhoneNumber: " + actualPhone);

      // Structure the form data
      const formData = {
        name: data.customerData.username ? data.customerData.username : "",
        phone: actualPhone,
        id: data.customerData.id ? data.customerData.id : "",
        email: applicantEmail,
        applicantId: applicantId,
        spouseId: actualSpouseId,
        spouseName: actualSpouseName,
        spouseEmail: actualSppouseEmail,
      };

      // Update the form data with the processed values
      setFormData(formData);
      validateEmail(applicantEmail);
    } catch (error) {
      setSnackbarMessage("Error: " + error.message);
      setSnackbarSeverity("error");
      setLoading(false);
      setSnackbarOpen(true);
      console.error("Error:", error);
      console.error("Error fetching data:", error);
    }
  };

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const fetchMediaFiles = async () => {
    try {
      const response = await fetch(
        `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/inboundchat-data/media-files?phone=${formData.phone}&source=TAX`
      ); // Replace with your API URL
      // const response = await fetch(`http://localhost:8080/inboundchat-data/media-files?phone=${formData.phone}&source=TAX`); // Replace with your API URL
      const data = await response.json();
      updateMediaFiles(data);
    } catch (error) {
      // setSnackbarMessage('Error: ' + error.message);
      // setSnackbarSeverity('error');
      // setLoading(false);
      // setSnackbarOpen(true);
      console.error("Error:", error);
      console.error("Error fetching media files:", error);
    }
  };

  const updateMediaFiles = (apiResponse) => {
    setMediaFiles((prevState) => {
      const existingUrls = new Set(prevState.map((file) => file.url)); // Get existing URLs

      const newFiles = apiResponse
        .filter((file) => !existingUrls.has(file.mediaUrl)) // Filter out duplicates
        .map((file) => ({
          description: file.description || "No description",
          url: file.mediaUrl,
          type: determineFileType(file.mediaUrl),
        }));

      return [...prevState, ...newFiles];
    });
  };

  // Function to determine the file type based on the file URL
  const determineFileType = (url) => {
    const extension = url.split(".").pop().toLowerCase();
    if (["pdf", "docx", "txt"].includes(extension)) {
      return extension;
    } else if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
      return "image";
    } else {
      return "unknown";
    }
  };

  const [mediaFiles, setMediaFiles] = useState([
    // { description: "Document 1", url: "https://rms.healtheesystems.com:9443/resource/Rules_(1).pdf", type: "pdf" },
    // { description: "Image 1", url: "https://rms.healtheesystems.com/webagent/custom/form/healthee_logo.jpg", type: "image" },
    // Add more media files here
  ]);

  const [showFile, setShowFile] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleShowFile = (file) => {
    setSelectedFile(file);
    setShowFile(true);
  };

  const handleCloseFile = () => {
    setShowFile(false);
    setSelectedFile(null);
  };

  const fetchLanguages = async () => {
    try {
      const response = await fetch(
        `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/sms-templates/language`
      );
      // const response = await fetch('http://localhost:8080/api/sms-templates/language');

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json(); // Parse the JSON response
      setLanguages(data);
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  };

  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === "Escape") {
        handleCloseFile();
      }
    };

    document.addEventListener("keydown", handleEscKey);

    // Cleanup event listener when component unmounts
    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, []);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  setInterval(fetchMediaFiles, 60000);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current); // Ensure only one interval exists
    }

    intervalRef.current = setInterval(() => {
      handleSubmit(null, false, true);
    }, 120000); // 2 minutes

    return () => {
      clearInterval(intervalRef.current); // Cleanup on unmount
    };
  }, []); // Empty dependency array ensures it runs only once

  return (
    <div className="app">
      <h1 className="title">{t.titleLabel}</h1>
      <div className="tabs">
        <button
          className={`tab ${activeTab === "tab1" ? "active" : ""}`}
          onClick={() => setActiveTab("tab1")}
          disabled={tabsDisabled}
        >
          {t.scriptLabel}
        </button>
        <button
          className={`tab ${activeTab === "tab4" ? "active" : ""}`}
          onClick={() => setActiveTab("tab4")}
          disabled={tabsDisabled}
        >
          E-Sign
        </button>
        <button
          className={`tab ${activeTab === "tab2" ? "active" : ""}`}
          onClick={() => setActiveTab("tab2")}
          disabled={tabsDisabled}
          hidden={smsTabHidden}
        >
          {t.sendSmsLabel}
        </button>

        <button
          className={`tab ${activeTab === "tab3" ? "active" : ""}`}
          onClick={() => setActiveTab("tab3")}
          disabled={tabsDisabled}
        >
          {t.mediaFilesLabel}
        </button>
      </div>
      <div className="language-selector">
        <select
          className="form-select w-auto"
          value={language}
          onChange={LanguageChange}
        >
          <option value="English">English</option>
          <option value="Spanish">Español</option>
        </select>
      </div>
      <div className="tab-content">
        {/* Tab 1 Content */}
        {activeTab === "tab1" && (
          <div className="content">
            {/* <p>
              Hello! My name is <strong>{agentName}</strong>, and I'm reaching out because I have an opportunity to put money in your pocket fast.
              Our tax office partners with banks that allow you to get an advance on your tax refund.
              In just 24 hours, you could have up to <strong>$7,000</strong> deposited directly into your bank account.
            </p> */}
            <p>
              {t.greeting} <strong>{agentName}</strong>, {t.opportunity}{" "}
              {t.taxAdvance}
              {t.marchAprilScript} {t.taxDeadlineNotice}
            </p>
            {/* <ul>
              <li>{t.avoidPenalties}</li>
              <li>{t.auditDefense}</li>
              <li>{t.businessDeductions}</li>
              <li>{t.cleanEnergyCredits}</li>
            </ul> */}

            {loading && (
              <div className="spinner-overlay">
                <div className="spinner"></div>
              </div>
            )}
            {/* <p>Let’s get started! To begin, all I need from you is your most recent paystub. Do you have that handy?</p>
            <p>Perfect! I’m going to text you a link to start the process. Just click on the link and follow the prompts to enter your information. I’ll stay on the line to guide you through each step, so you're fully supported.</p> */}
            <form onSubmit={handleSubmit}>
              <div className="form-row d-flex justify-content-between">
                <div className="form-group flex-grow-1 me-2">
                  <label htmlFor="name">{t.nameLabel}</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-control"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    readOnly={isReadOnly}
                  />
                </div>
                <div className="form-group flex-grow-1 ms-2">
                  <label htmlFor="phone">{t.phoneLabel}</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="form-control"
                    placeholder="Enter your phone number"
                    value={formData.phone}
                    onChange={handleChange}
                    readOnly
                  />
                </div>
              </div>
              <div className="form-row d-flex justify-content-between mt-3">
                <div className="form-group flex-grow-1 me-2">
                  <label htmlFor="email">{t.emailLabel}</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    readOnly={isReadOnly}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="qCode">{t.selectQCode}</label>
                  <select
                    id="qCode"
                    name="qCode"
                    className="form-control mb-3" // Added bottom margin
                    value={formData.qCode}
                    onChange={handleChange}
                    required
                    disabled={isReadOnly} // Disable the select field if read-only
                  >
                    <option value="">Select a QCode</option>
                    {options.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row d-flex justify-content-between mt-3">
                <div className="form-group flex-grow-1 me-2" hidden>
                  <label htmlFor="id">ID:</label>
                  <input
                    type="text"
                    id="id"
                    name="id"
                    className="form-control"
                    placeholder="Enter ID"
                    value={formData.id}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group flex-grow-1 ms-2" hidden>
                  <label htmlFor="applicantId">Applicant ID:</label>
                  <input
                    type="text"
                    id="applicantId"
                    name="applicantId"
                    className="form-control"
                    placeholder="Enter Applicant ID"
                    value={formData.applicantId}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-row d-flex align-items-center gap-2 mt-3">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                      size="small"
                    />
                  }
                  label="If you want to join the account"
                  sx={{ color: "black" }} // Sets text color to black
                />
              </div>
              {isChecked && (
                <div className="form-row d-flex justify-content-between mt-3">
                  <div className="form-group flex-grow-1 me-2">
                    <label htmlFor="spouseName">{t.spouseNameLabel}</label>
                    <input
                      type="text"
                      id="spouseName"
                      name="spouseName"
                      className="form-control"
                      placeholder="Enter your name"
                      value={formData.spouseName}
                      onChange={handleChange}
                      disabled={!isChecked} // Disable if checkbox is unchecked
                      required={isChecked} // Make required if checkbox is checked
                    />
                  </div>
                  <div className="form-group flex-grow-1 me-2">
                    <label htmlFor="spouseEmail">{t.spouseEmailLabel}</label>
                    <input
                      type="email"
                      id="spouseEmail"
                      name="spouseEmail"
                      className="form-control"
                      placeholder="Enter your email"
                      value={formData.spouseEmail}
                      onChange={handleChange}
                      disabled={!isChecked} // Disable if checkbox is unchecked
                      required={isChecked} // Make required if checkbox is checked
                    />
                  </div>
                </div>
              )}
              <div className="button-row d-flex justify-content-between mt-3">
                {showButtons && (
                  <>
                    <button type="submit" className="btn btn-primary">
                      {t.submit}
                    </button>
                    {/* {isEmailValid && (
                      <button
                        type="button"
                        className="btn btn-secondary ms-2"
                        onClick={handleDocusign}
                      >
                        Initiate e-sign
                      </button>
                    )} */}
                  </>
                )}
              </div>
              <div className="additional-button-div mt-3">
                {showCloseButtons && (
                  <button
                    type="button"
                    className="btn btn-info"
                    onClick={handleCloseContact} // Make sure to define this function
                  >
                    Close Contact
                    {/* {t.newButtonLabel}  */}
                  </button>
                )}
                {/* <div className="mt-3">
                  {showBotSummaryButtons && (
                    <button
                      type="button"
                      className="btn btn-info"
                      onClick={handleBotSummary} // Ensure to define the handleBotSummary function
                    >
                      Bot Summary
                    </button>
                  )}
                </div> */}
              </div>
              {isDialogOpen && (
                <div className="dialog-backdrop" onClick={closeDialog}></div>
              )}
              <dialog open={isDialogOpen} className="bot-summary-dialog">
                <h3>Bot Summary</h3>
                <div className="summary-content">
                  {summaryData}{" "}
                  {/* Displays the formatted data with line breaks */}
                </div>
                <button onClick={closeDialog} className="btn btn-info">
                  Close
                </button>
              </dialog>
            </form>
          </div>
        )}

        {activeTab === "tab2" && (
          <div className="content">
            <h2>{t.sendMessageHeader}</h2>
            {loading && (
              <div className="spinner-overlay">
                <div className="spinner"></div>
              </div>
            )}
            <div className="form-group">
              <label htmlFor="phoneNumber">{t.phoneLabel}</label>
              <input
                type="text"
                id="phoneNumber"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Enter phone number"
              />
            </div>
            <div className="form-group">
              <label htmlFor="templateSelect">Select Template</label>
              <select
                id="templateSelect"
                value={selectedTemplate}
                onChange={(e) => {
                  setSelectedTemplate(e.target.value);
                  handleTemplateChange(e); // Pass the event to the handleTemplateChange function
                }}
                className="form-control"
              >
                <option value="">-- Select a Template --</option>
                {templates && templates.length > 0 ? (
                  templates.map(
                    (template, index) =>
                      // Ensure the template is not undefined and is a valid string
                      template &&
                      typeof template === "string" && (
                        <option key={index} value={template}>
                          {template.charAt(0).toUpperCase() + template.slice(1)}{" "}
                          {/* Capitalizing the first letter */}
                        </option>
                      )
                  )
                ) : (
                  <option>No templates available</option>
                )}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="languageSelect">Select Language</label>
              <select
                id="languageSelect"
                value={selectedLanguage}
                onChange={(e) => {
                  setSelectedLanguage(e.target.value); // Set the selected language
                  handleLanguageChange(e); // Pass the event to the handleTemplateChange function
                }}
                className="form-control"
              >
                <option value="">-- Select a Language --</option>
                {languages.map((language, index) => (
                  <option key={index} value={language}>
                    {language.charAt(0).toUpperCase() + language.slice(1)}{" "}
                    {/* Capitalizing the first letter */}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="messageContent">{t.messageLabel}</label>
              <textarea
                id="messageContent"
                value={messageContent}
                onChange={(e) => setMessageContent(e.target.value)}
                placeholder="Enter your message"
              />
            </div>
            <button onClick={handleSendMessage} className="send-button">
              {t.sendMessageLabel}
            </button>
          </div>
        )}

        {activeTab === "tab3" && (
          <div className="content">
            <h2>{t.mediaFilesHeader}</h2>

            <div className="media-file-list">
              {mediaFiles.map((file, index) => (
                <div className="media-file" key={index}>
                  <p>{file.description}</p>
                  <div
                    className="file-icon-container"
                    onClick={() => handleShowFile(file)}
                  >
                    <FileOpenTwoToneIcon className="MuiSvgIcon-root" />{" "}
                    {/* Material UI icon */}
                  </div>
                </div>
              ))}
            </div>

            {/* Modal or popup for displaying the selected file */}
            {showFile && (
              <div className="file-modal">
                <div className="modal-content">
                  <span className="close" onClick={handleCloseFile}>
                    &times;
                  </span>
                  <h3>{selectedFile?.description}</h3>
                  <div className="file-viewer">
                    {selectedFile?.type === "image" ? (
                      <img
                        src={selectedFile?.url}
                        alt={selectedFile?.description}
                      />
                    ) : selectedFile?.type === "pdf" ? (
                      <embed
                        src={selectedFile?.url}
                        type="application/pdf"
                        width="100%"
                        height="600px"
                      />
                    ) : selectedFile?.type === "video" ? (
                      <video controls width="100%">
                        <source src={selectedFile?.url} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    ) : selectedFile?.type === "audio" ? (
                      <audio controls>
                        <source src={selectedFile?.url} type="audio/mp3" />
                        Your browser does not support the audio tag.
                      </audio>
                    ) : selectedFile?.type === "text" ? (
                      <pre>{selectedFile?.content}</pre> // Assuming content is plain text
                    ) : (
                      <p>File type not supported for preview.</p>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === "tab4" && (
          <div className="content">
            {loading && (
              <div className="spinner-overlay">
                <div className="spinner"></div>
              </div>
            )}
            <h2>Select an E-Sign Option</h2>
            <select
              value={eSignSelectedOption}
              onChange={(e) => setESignSelectedOption(e.target.value)}
              className="dropdown"
            >
              <option value="" disabled>
                Select an option
              </option>
              {eSigOptions.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>

            {/* Show form if "DIRECT DEPOSIT AUTHORIZATION & DISCLOSURE" is selected */}
            {eSignSelectedOption ===
              "DIRECT DEPOSIT AUTHORIZATION & DISCLOSURE" && (
              <div className="form-container">
                <h3>Authorization Agreement for Direct Deposit</h3>

                <div className="form-group">
                  <span className="authorization-text">
                    I, <strong>{formData.name}</strong> hereby authorize
                    [Company/Organization Name] (the "Company") to initiate
                    electronic credit entries to my bank account as listed below
                    for tax refunds, reimbursements, or other authorized
                    deposits. If necessary, I authorize debit entries for
                    corrections of erroneous credit transactions.
                  </span>
                </div>

                <h4>Bank Account Information</h4>
                <div className="form-row d-flex justify-content-between">
                  <div className="form-group flex-grow-1 me-2">
                    <label>Bank Name:</label>
                    <input
                      type="text"
                      id="bankName"
                      name="bankName"
                      className="form-control"
                      placeholder="Enter Bank name"
                      value={formData.bankName}
                      onChange={handleChange}
                    />
                    {/* <input type="text" placeholder="Enter Bank Name" value={formData.formData.bankName} /> */}
                  </div>
                  <div className="form-group flex-grow-1 ms-2">
                    <label>Bank Routing Number:</label>
                    <input
                      type="text"
                      id="routingNumber"
                      name="routingNumber"
                      className="form-control"
                      placeholder="Enter Routing Number"
                      value={formData.routingNumber}
                      onChange={handleRoutingNumberChange}
                      maxLength={9} // Limit input to 9 digits
                    />
                    {/* <input type="text" placeholder="Enter Routing Number" value={formData.routingNumber} /> */}
                  </div>
                </div>
                <div className="form-row d-flex justify-content-between">
                  <div className="form-group flex-grow-1 me-2">
                    <label>Bank Account Number:</label>
                    <input
                      type="text"
                      id="accountNumber"
                      name="accountNumber"
                      className="form-control"
                      placeholder="Enter Account Number"
                      value={formData.accountNumber}
                      onChange={handleAccountNumberChange}
                      maxLength={17} // Restrict max length to 17
                    />
                    {/* <input type="text" placeholder="Enter Account Number" value={formData.accountNumber} /> */}
                  </div>
                  <div className="form-group flex-grow-1 ms-2">
                    <label>Account Type:</label>
                    <input
                      type="text"
                      id="accountType"
                      name="accountType"
                      className="form-control"
                      placeholder="Enter Account Type"
                      value={formData.accountType}
                      onChange={handleChange}
                    />
                    {/* <input type="text" placeholder="Enter Account Type" value={formData.accountType} /> */}
                  </div>
                </div>

                <div className="taxpayer-disclosure">
                  <h4>Taxpayer Responsibility & Disclosure</h4>
                  <ul>
                    <li>
                      Accuracy of Banking Information: I certify that the
                      banking details provided above are accurate and belong to
                      me. I understand that providing incorrect banking
                      information may result in deposit errors, delays, or the
                      inability to process my payment.
                    </li>
                    <li>
                      Duty to Verify Information: I acknowledge that it is my
                      responsibility to double-check and confirm that the
                      routing number and account number provided are correct.
                      Any errors due to incorrect information are my sole
                      responsibility.
                    </li>
                    <li>
                      Liability Disclaimer: I acknowledge that
                      [Company/Organization Name] is not responsible for any
                      lost funds, incorrect deposits, bank fees, overdraft
                      charges, or delays resulting from incorrect information
                      provided by me.
                    </li>
                    <li>
                      Corrections &amp; Adjustments: If an incorrect deposit is
                      made, I authorize [Company/Organization Name] to correct
                      the error by initiating a reversing transaction.
                    </li>
                    <li>
                      Processing Time: I understand that processing times for
                      direct deposit transactions vary and may be subject to
                      bank policies and IRS regulations.
                    </li>
                    <li>
                      Notification of Changes: I agree to notify
                      [Company/Organization Name] immediately in writing if I
                      change my bank account details. I understand that failure
                      to do so may result in delays or misdirected payments.
                    </li>
                  </ul>
                </div>

                <div className="acknowledgment-form">
                  <h4>Acknowledgment & Signature</h4>

                  <div className="form-group">
                    <span className="authorization-text">
                      By signing this form, I confirm that the direct deposit
                      information provided is accurate and that I am the
                      authorized account holder. I accept full responsibility
                      for any errors or financial consequences resulting from
                      incorrect or outdated banking details.
                    </span>
                  </div>

                  <div className="form-group">
                    <label>
                      Taxpayer Name (Print): _________________________
                    </label>
                    {/* <span className="input-line"><input type="text" /></span> */}
                  </div>

                  <div className="form-group">
                    <label>
                      Taxpayer Signature: ____________________________
                    </label>
                    {/* <span className="input-line"><input type="text" /></span> */}
                  </div>

                  <div className="form-group">
                    <label>Date: _________________________</label>
                    {/* <span className="input-line"><input type="date" /></span> */}
                  </div>
                </div>
              </div>
            )}

            {eSignSelectedOption === "TAX RETURN DISCLOSURE" && (
              <div className="form-container">
                <h3>TAX RETURN DISCLOSURE & LIABILITY STATEMENT UNDER OATH</h3>

                <h4>IMPORTANT NOTICE TO TAXPAYER</h4>

                <div className="taxpayer-disclosure">
                  <h4>
                    This disclosure serves as a formal notice regarding the
                    preparation and filing of your tax return. By signing below,
                    you acknowledge and agree to the following terms under oath:
                  </h4>
                  <ul>
                    <li>
                      Taxpayer Responsibility: You, as the taxpayer, swear under
                      oath that all information provided for the preparation of
                      your tax return is accurate, complete, and truthful. You
                      affirm that it is your duty to review all financial
                      records, statements, and supporting documents before
                      submission.
                    </li>
                    <li>
                      Preparer’s Role: The tax preparer has prepared this return
                      based on the information you have provided. The preparer
                      does not audit, verify, or validate any data. The preparer
                      is not responsible for any inaccuracies, omissions, or
                      misrepresentations made by the taxpayer.
                    </li>
                    <li>
                      Accuracy of Information: You affirm under penalty of
                      perjury that all income, deductions, credits, and other
                      tax-related items reported in your tax return are true,
                      correct, and supported by appropriate documentation. Any
                      false or misleading information may subject you to
                      penalties, interest, or legal consequences, including
                      prosecution under tax fraud statutes.
                    </li>
                    <li>
                      IRS and State Audits: In the event of an IRS or state
                      audit, you understand that it is your duty to provide
                      supporting documentation and respond to inquiries from tax
                      authorities. The tax preparer is not responsible for
                      defending, representing, or addressing any audits unless a
                      separate engagement agreement is signed.
                    </li>
                    <li>
                      Penalties and Interest: Any penalties or interest assessed
                      by the IRS or state agencies due to errors, misstatements,
                      underreporting, or failure to provide complete and
                      accurate information are solely the taxpayer’s
                      responsibility.
                    </li>
                    <li>
                      No Guarantee of Outcome: The tax preparer does not
                      guarantee or warrant the acceptance, refund amount, or
                      audit-free status of your tax return. The tax return is
                      prepared based on current tax laws and regulations, which
                      may change at any time.
                    </li>
                    <li>
                      Electronic Filing &amp; Acknowledgment: If you opt for
                      electronic filing, you authorize the preparer to submit
                      your tax return electronically to the IRS and/or state tax
                      agencies. You acknowledge that electronic submission does
                      not exempt you from liability for any errors or omissions
                      within the return.
                    </li>
                    <li>
                      Hold Harmless Agreement: You agree to hold the tax
                      preparer harmless from any liability, damages, or legal
                      consequences resulting from the filing of your tax return.
                      You assume full responsibility for any decisions made
                      based on your tax return.
                    </li>
                  </ul>
                </div>

                <div className="acknowledgment-form">
                  <h4>OATH &amp; ACKNOWLEDGMENT</h4>

                  <div className="form-group">
                    <span className="authorization-text">
                      I, <strong>{formData.name}</strong> (Taxpayer’s Name),
                      swear under oath that I have reviewed my tax return and
                      affirm that I am solely responsible for its accuracy and
                      completeness. I release the tax preparer from any legal or
                      financial liability related to my tax return. I understand
                      that any false statements may be punishable under
                      applicable laws.
                    </span>
                  </div>

                  <div className="form-group">
                    <label>
                      Taxpayer Signature: ____________________________
                    </label>
                    {/* <span className="input-line"><input type="text" /></span> */}
                  </div>

                  <div className="form-group">
                    <label>Date: _________________________</label>
                    {/* <span className="input-line"><input type="date" /></span> */}
                  </div>

                  <div className="form-group">
                    <label>
                      Spouse’s Signature (if applicable):
                      ____________________________
                    </label>
                    {/* <span className="input-line"><input type="text" /></span> */}
                  </div>

                  <div className="form-group">
                    <label>Date: _________________________</label>
                    {/* <span className="input-line"><input type="date" /></span> */}
                  </div>
                </div>
              </div>
            )}

            {eSignSelectedOption ===
              "SCHEDULE C - BUSINESS EXPENSE DISCLOSURE" && (
              <div className="form-container">
                <h3>SCHEDULE C - BUSINESS EXPENSE DISCLOSURE</h3>
                <p>
                  This disclosure outlines deductible business expenses under{" "}
                  <strong>IRS Code Section 162</strong>, which allows for the
                  deduction of ordinary and necessary expenses incurred in
                  carrying on a trade or business. Taxpayers must ensure
                  compliance with IRS regulations and maintain supporting
                  documentation for all expenses claimed.
                </p>

                <h4>Taxpayer Information</h4>
                <div className="form-row d-flex justify-content-between">
                  <div className="form-group flex-grow-1 me-2">
                    <label>Name:</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Enter name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {/* <input type="text" placeholder="Enter Name" value={formData.name} /> */}
                  </div>
                  <div className="form-group flex-grow-1 ms-2">
                    <label>
                      Employer Identification Number (EIN) (if applicable):
                    </label>
                    <input
                      type="text"
                      id="ein"
                      name="ein"
                      className="form-control"
                      placeholder="Enter EIN"
                      value={formData.ein}
                      onChange={handleEINChange}
                      maxLength={10} // Prevent extra input
                    />
                    {/* <input type="text" placeholder="Enter EIN" value={formData.ein} /> */}
                  </div>
                </div>

                <div className="form-row d-flex justify-content-between">
                  <div className="form-group flex-grow-1 me-2">
                    <label>Business Name:</label>
                    <input
                      type="text"
                      id="businessName"
                      name="businessName"
                      className="form-control"
                      placeholder="Enter Business name"
                      value={formData.businessName}
                      onChange={handleChange}
                    />
                    {/* <input type="text" placeholder="Enter Business Name" value={formData.businessName} /> */}
                  </div>
                  <div className="form-group flex-grow-1 ms-2">
                    <label>Tax Year:</label>
                    <input
                      type="text"
                      id="taxYear"
                      name="taxYear"
                      className="form-control"
                      placeholder="Enter Tax year"
                      value={formData.taxYear}
                      onChange={handleChange}
                    />
                    {/* <input type="text" placeholder="Enter Tax Year" value={formData.taxYear} /> */}
                  </div>
                </div>

                {/* <h4>ORDINARY & NECESSARY BUSINESS EXPENSES</h4>
              <ul className="expense-list" style={{ textAlign: "left", paddingLeft: "20px" }}>
                <li>Advertising & Marketing - <input type="number" placeholder="Enter amount" /></li>
                <li>Business Insurance (e.g., liability, workers' compensation) - <input type="number" placeholder="Enter amount" /></li>
                <li>Commissions & Fees - <input type="number" placeholder="Enter amount" /></li>
                <li>Contract Labor (Form 1099-NEC required if applicable) - <input type="number" placeholder="Enter amount" /></li>
                <li>Depreciation & Amortization (attach Form 4562 if required) - <input type="number" placeholder="Enter amount" /></li>
                <li>Employee Benefits (excluding owner benefits) - <input type="number" placeholder="Enter amount" /></li>
                <li>Legal & Professional Services - <input type="number" placeholder="Enter amount" /></li>
                <li>Office Expenses (supplies, software, small equipment, etc.) - <input type="number" placeholder="Enter amount" /></li>
                <li>Rent or Lease (business property & equipment) - <input type="number" placeholder="Enter amount" /></li>
                <li>Repairs & Maintenance - <input type="number" placeholder="Enter amount" /></li>
                <li>Travel (lodging, airfare, meals at 50%) - <input type="number" placeholder="Enter amount" /></li>
                <li>Utilities (phone, internet, electricity for business use) - <input type="number" placeholder="Enter amount" /></li>
                <li>Vehicle Expenses (standard mileage or actual expenses) - <input type="number" placeholder="Enter amount" /></li>
                <li>Wages (excluding owner compensation) - <input type="number" placeholder="Enter amount" /></li>
                <li>Other Expenses (must be ordinary & necessary) - <input type="number" placeholder="Enter amount" /></li>
              </ul> */}

                <h4>ORDINARY & NECESSARY BUSINESS EXPENSES</h4>
                <ul
                  className="expense-list"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    listStyle: "none",
                  }}
                >
                  {scheduleCExpense.map((expense, index) => (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ flex: 1, textAlign: "left" }}>
                        {expense}
                      </span>
                      <input
                        type="number"
                        placeholder="Enter amount"
                        style={{
                          textAlign: "right",
                          marginRight: "10px",
                          width: "150px",
                        }} // Right-align input text
                        min="0"
                        step="0.01"
                        value={schduleCAmounts[index] || ""}
                        onChange={(e) =>
                          handleScheduleCExpenseChange(index, e.target.value)
                        }
                      />
                    </li>
                  ))}
                </ul>

                <div
                  className="form-group"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label style={{ flex: 1 }}>Total Taxes Paid: $</label>
                  <input
                    type="number"
                    style={{
                      marginLeft: "10px",
                      width: "150px",
                      fontWeight: "bold",
                    }}
                    value={totalScheduleC.toFixed(2)}
                    readOnly
                  />
                </div>

                <h4>NON-DEDUCTIBLE EXPENSES</h4>
                <p style={{ textAlign: "left", paddingLeft: "20px" }}>
                  Per IRS guidelines, the following expenses are not deductible
                  on Schedule C:
                </p>
                <ul
                  className="non-deductible-list"
                  style={{ textAlign: "left", paddingLeft: "20px" }}
                >
                  <li>Personal expenses unrelated to the business</li>
                  <li>Fines and penalties paid to the government</li>
                  <li>Lobbying or political contributions</li>
                  <li>Personal entertainment expenses</li>
                  <li>
                    Capital expenditures (must be depreciated if applicable)
                  </li>
                </ul>
                <h4>DOCUMENTATION REQUIREMENTS</h4>
                <p>
                  Taxpayers must retain receipts, invoices, bank statements, and
                  other documentation to substantiate each expense claimed.
                  Failure to maintain records may result in disallowance of
                  deductions and potential penalties.
                </p>

                <h4>ACKNOWLEDGMENT & CERTIFICATION</h4>
                <div className="form-group">
                  <label>I, </label>
                  <span className="input-line">
                    <strong>{formData.name}</strong>
                  </span>
                  , certify under penalty of perjury that the expenses reported
                  above are accurate, properly documented, and comply with{" "}
                  <strong>IRS Code Section 162</strong> for business deductions.
                </div>

                <div className="form-group">
                  <label>Taxpayer Signature:</label>
                  <span className="input-line">
                    ___________________________
                  </span>
                </div>

                <div className="form-group">
                  <label>Date:</label>
                  <span className="input-line">
                    ___________________________
                  </span>
                </div>
              </div>
            )}

            {eSignSelectedOption ===
              "SCHEDULE A - ITEMIZED DEDUCTIONS TEMPLATE" && (
              <div className="form-container">
                <h3>SCHEDULE A - ITEMIZED DEDUCTIONS TEMPLATE</h3>
                <p>
                  This template provides a structured format for taxpayers to
                  track and report deductible expenses allowed on Schedule A of
                  the IRS Form 1040. Taxpayers must retain supporting
                  documentation for all deductions claimed to ensure compliance
                  with tax laws.
                </p>

                <h4>Taxpayer Information</h4>
                <div className="form-row d-flex justify-content-between">
                  <div className="form-group flex-grow-1 me-2">
                    <label>Name:</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Enter name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {/* <input type="text" placeholder="Enter Name" value={formData.name} /> */}
                  </div>
                  <div className="form-group flex-grow-1 me-2">
                    <label>Social Security Number:</label>
                    <input
                      type="text"
                      id="socialSecurityNumber"
                      name="socialSecurityNumber"
                      className="form-control"
                      placeholder="Enter SSN"
                      value={formData.socialSecurityNumber}
                      onChange={handleSSNChange} // Use the custom handler
                      maxLength={11} // Includes dashes
                    />
                  </div>
                </div>
                <div className="form-row d-flex justify-content-between">
                  <div className="form-group flex-grow-1 ms-2">
                    <label>Tax Year:</label>
                    <input
                      type="text"
                      id="taxYear"
                      name="taxYear"
                      className="form-control"
                      placeholder="Enter Tax year"
                      value={formData.taxYear}
                      onChange={handleChange}
                    />
                    {/* <input type="text" placeholder="Enter Tax Year" value={formData.taxYear} /> */}
                  </div>
                </div>

                <h4>
                  MEDICAL AND DENTAL EXPENSES (Must exceed 7.5% of AGI to be
                  deductible)
                </h4>
                <ul
                  className="expense-list"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    listStyle: "none",
                  }}
                >
                  {medicalExpenses.map((expense, index) => (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ flex: 1 }}>{expense}</span>
                      <input
                        type="number"
                        placeholder="Enter amount"
                        style={{ marginLeft: "10px", width: "150px" }}
                        min="0"
                        step="0.01"
                        value={amounts[index] || ""}
                        onChange={(e) =>
                          handleMedicalExpenseChange(index, e.target.value)
                        }
                      />
                    </li>
                  ))}
                </ul>

                <div
                  className="form-group"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label style={{ flex: 1 }}>
                    Total Medical and Dental Expenses: $
                  </label>
                  <input
                    type="number"
                    style={{
                      marginLeft: "10px",
                      width: "150px",
                      fontWeight: "bold",
                    }}
                    value={medicalExpense.toFixed(2)}
                    readOnly
                  />
                </div>

                <h4>
                  TAXES YOU PAID (State and local tax deduction limited to
                  $10,000 per year)
                </h4>
                <ul
                  className="expense-list"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    listStyle: "none",
                  }}
                >
                  {paidExpenses.map((expense, index) => (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ flex: 1 }}>{expense}</span>
                      <input
                        type="number"
                        placeholder="Enter amount"
                        style={{ marginLeft: "10px", width: "150px" }}
                        min="0"
                        step="0.01"
                        value={paidAmounts[index] || ""}
                        onChange={(e) =>
                          handlePaidExpenseChange(index, e.target.value)
                        }
                      />
                    </li>
                  ))}
                </ul>

                <div
                  className="form-group"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label style={{ flex: 1 }}>Total Taxes Paid: $</label>
                  <input
                    type="number"
                    style={{
                      marginLeft: "10px",
                      width: "150px",
                      fontWeight: "bold",
                    }}
                    value={paidExpense.toFixed(2)}
                    readOnly
                  />
                </div>

                <h4>INTEREST YOU PAID</h4>
                <ul
                  className="expense-list"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    listStyle: "none",
                  }}
                >
                  {paidInterestExpenses.map((expense, index) => (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ flex: 1 }}>{expense}</span>
                      <input
                        type="number"
                        placeholder="Enter amount"
                        style={{ marginLeft: "10px", width: "150px" }}
                        min="0"
                        step="0.01"
                        value={paidInterestAmounts[index] || ""}
                        onChange={(e) =>
                          handlePaidInterestExpenseChange(index, e.target.value)
                        }
                      />
                    </li>
                  ))}
                </ul>

                <div
                  className="form-group"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label style={{ flex: 1 }}>Total Taxes Paid: $</label>
                  <input
                    type="number"
                    style={{
                      marginLeft: "10px",
                      width: "150px",
                      fontWeight: "bold",
                    }}
                    value={totalPaidInterestExpense.toFixed(2)}
                    readOnly
                  />
                </div>

                <h4>
                  GIFTS TO CHARITY (Must be made to a qualified 501(c)(3)
                  organization and properly documented)
                </h4>
                <ul
                  className="expense-list"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    listStyle: "none",
                  }}
                >
                  {giftToCharityExpenses.map((expense, index) => (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ flex: 1 }}>{expense}</span>
                      <input
                        type="number"
                        placeholder="Enter amount"
                        style={{ marginLeft: "10px", width: "150px" }}
                        min="0"
                        step="0.01"
                        value={giftAmount[index] || ""}
                        onChange={(e) =>
                          handleGitAmountChange(index, e.target.value)
                        }
                      />
                    </li>
                  ))}
                </ul>

                <div
                  className="form-group"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label style={{ flex: 1 }}>
                    Total Charitable Contributions: $
                  </label>
                  <input
                    type="number"
                    style={{
                      marginLeft: "10px",
                      width: "150px",
                      fontWeight: "bold",
                    }}
                    value={totalGiftAmount.toFixed(2)}
                    readOnly
                  />
                </div>

                <h4>
                  CASUALTY AND THEFT LOSSES (Must be due to a federally declared
                  disaster and exceed 10% of AGI)
                </h4>
                <ul
                  className="expense-list"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    listStyle: "none",
                  }}
                >
                  {casualtyTeftExpenses.map((expense, index) => (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ flex: 1 }}>{expense}</span>
                      <input
                        type="number"
                        placeholder="Enter amount"
                        style={{ marginLeft: "10px", width: "150px" }}
                        min="0"
                        step="0.01"
                        value={casulatyTeftAmounts[index] || ""}
                        onChange={(e) =>
                          handleCasualtyChange(index, e.target.value)
                        }
                      />
                    </li>
                  ))}
                </ul>

                <div
                  className="form-group"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label style={{ flex: 1 }}>
                    Total Casualty and Theft Loss Deduction: $
                  </label>
                  <input
                    type="number"
                    style={{
                      marginLeft: "10px",
                      width: "150px",
                      fontWeight: "bold",
                    }}
                    value={totalCasualty.toFixed(2)}
                    readOnly
                  />
                </div>

                <h4>
                  MISCELLANEOUS DEDUCTIONS (Only deductible if allowed under
                  current tax law)
                </h4>
                <ul
                  className="expense-list"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    listStyle: "none",
                  }}
                >
                  {miscellaneousExpenses.map((expense, index) => (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ flex: 1 }}>{expense}</span>
                      <input
                        type="number"
                        placeholder="Enter amount"
                        style={{ marginLeft: "10px", width: "150px" }}
                        min="0"
                        step="0.01"
                        value={miscellaneousAmounts[index] || ""}
                        onChange={(e) =>
                          handleMiscelaneousChange(index, e.target.value)
                        }
                      />
                    </li>
                  ))}
                </ul>

                <div
                  className="form-group"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label style={{ flex: 1 }}>
                    Total Miscellaneous Deductions: $
                  </label>
                  <input
                    type="number"
                    style={{
                      marginLeft: "10px",
                      width: "150px",
                      fontWeight: "bold",
                    }}
                    value={totalMicellaneous.toFixed(2)}
                    readOnly
                  />
                </div>

                <h4>TOTAL ITEMIZED DEDUCTIONS</h4>
                <ul
                  className="expense-list"
                  style={{
                    textAlign: "center",
                    paddingLeft: "20px",
                    listStyle: "none",
                  }}
                >
                  <h5 style={{ margin: "0" }}>
                    (Add up all deductible amounts from sections above)
                  </h5>
                </ul>

                <div
                  className="form-group"
                  style={{
                    textAlign: "left",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label style={{ flex: 1 }}>
                    Grand Total Schedule A Deductions: $
                  </label>
                  <input
                    type="number"
                    style={{
                      marginLeft: "10px",
                      width: "150px",
                      fontWeight: "bold",
                    }}
                    value={grandTotal.toFixed(2)}
                    readOnly
                  />
                </div>

                <h4>ACKNOWLEDGMENT & CERTIFICATION</h4>
                <div className="form-group">
                  <label>I, </label>
                  <span className="input-line">
                    <strong>{formData.name}</strong>
                  </span>
                  , certify under penalty of perjury that the expenses reported
                  above are accurate, properly documented, and comply with IRS
                  regulations for itemized deductions.
                </div>

                <div className="form-group">
                  <label>Taxpayer Signature:</label>
                  <span className="input-line">
                    ___________________________
                  </span>
                </div>

                <div className="form-group">
                  <label>Date:</label>
                  <span className="input-line">
                    ___________________________
                  </span>
                </div>

                <div className="form-group">
                  <label>
                    Spouse’s Signature (if applicable):
                    ____________________________
                  </label>
                  {/* <span className="input-line"><input type="text" /></span> */}
                </div>

                <div className="form-group">
                  <label>Date: _________________________</label>
                  {/* <span className="input-line"><input type="date" /></span> */}
                </div>
              </div>
            )}

            <div className="button-row d-flex justify-content-between mt-3">
              {showButtons && (
                <>
                  {/* <button type="submit" className="btn btn-primary">
                    {t.submit}
                  </button> */}
                  {isEmailValid && (
                    <button
                      type="button"
                      className="btn btn-secondary ms-2"
                      onClick={handleDocusign}
                    >
                      Initiate e-sign
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default App;
